<template>
    <div>
    	<div class="header" >
	      <p></p>
	    </div>
			<div class="findWrap">
					<el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline" style="text-align: left;">
						
						<el-form-item label="时间范围" class="dateWarp">
							<el-date-picker :clearable="false" 
								style="width: 100%;"
								v-model="formInline.range"
								format="yyyy 年 MM 月 dd 日"
								value-format="yyyy-MM-dd"
								type="daterange"
								range-separator="--"
								start-placeholder="开始日期"
								end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="提现进度">
							<el-select v-model="formInline.status" placeholder="请选择提现进度">
								<el-option label="全部" value="10000000"></el-option>
								<el-option label="等待审核" value="0"></el-option>
								<el-option label="待交发票" value="1"></el-option>
								<el-option label="等待转账" value="2"></el-option>
								<el-option label="提现成功" value="3"></el-option>
								<el-option label="提现失败" value="4"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				<div class="right com">
					<div class="btn">
						<el-button @click="find" type="primary" style="height: 35px;line-height: 10px;">查询</el-button>
							<el-button @click="resetForm" type="info" style="height: 35px;line-height: 10px;">重置</el-button>
							<!-- <el-button @click="exportExcel" type="primary" style="height: 35px;line-height: 10px;">导出报表</el-button> -->
					</div>
				</div>
			</div>	
		<div class="total">{{totalStr }}</div>

		 <el-table
		    :data="tableData"
		    stripe
		    :header-cell-style="cell"
		    style="width: 100%;">
		    <el-table-column
					:formatter="tofixed"
		  	  align="center"
		      prop="amount"
		      label="提现金额(元)"
		    >
		    </el-table-column>
           <el-table-column
					:formatter="tofixed"
		    	align="center"
		      prop="successCashAmount"
		      label="转账金额（按费率扣款）"
		    >
		    </el-table-column>
           <el-table-column
		    	align="center"
		      prop="createTime"
		      label="提现时间"
		  >
		    </el-table-column>
		    <el-table-column
		    	align="center"
		      prop="text"
		      label="提现进度">
		    </el-table-column>
		 </el-table>
		 <!-- 页码 -->
			<div class="pageWrap">
				<el-pagination
					:current-page.sync="currentPage"
					:page-size="pageSize"
					layout="prev, pager, next, jumper"
					:total="count"
					@current-change="clickPage"
					>
				</el-pagination>
			</div>
    </div>
</template>

<script>
import { getMoneyList } from "@/api/merchant/merDetail"; 
import { toFixed } from "@/utils";
import { downloadExcel } from "@/utils/downloadFetch";
import {shop_url} from '@/global';
export default {
  name: "",
  props: [""],
  data() {
    return {
			mchId: 0, //商户id
      currentPage: 1,
      count: 0,
			pageSize: 10,
			status:'',
			withDrawList: [],
			totalStr:'',//总数据
      formInline: {
        range: [],
        orderId: "",
        status: "",
        start: "",
        end: ""
      }
    };
	},
	created() {
		this.mchId = this.$route.query.id;
		if(this.$route.query.status) {
			this.formInline.status = this.$route.query.status;
		}
    this._getMoneyList();
	},
	computed: {
		tableData() {
			let list = this.withDrawList;
			let len = this.withDrawList.length;
			for(let i=0;i<len;i++) {
				list[i]['text'] = list[i].status == 0 ? '等待审核' : list[i].status == 1 ? '提交发票' : list[i].status == 2 ? '等待转账' : list[i].status == 3 ? '提现成功' : '提现失败';
			}
			return list;
		}
	},
  methods: {
	 tofixed(row,column,cellValue) {
      return toFixed(cellValue)
    },
    find() {
			 this.withDrawList=[];
      this.currentPage = 1;
      this._getMoneyList();
    },
    clickPage(currentPage) {
      this.currentPage = currentPage;
      this._getMoneyList();
    },
    resetForm() {
      this.formInline = {
        range: [],
        orderId: "",
        status: "",
        start: "",
        end: ""
			};
			this.currentPage = 1;
      this._getMoneyList();
		},
		 _getMoneyList() {
      const data = {
        id: Number(this.mchId),
        end: this.formInline.range[1],
        page: this.currentPage,
        rows: this.pageSize,
        start: this.formInline.range[0],
        status: this.formInline.status == "" ? 10000 : Number(this.formInline.status)
      };
      getMoneyList(data)
        .then(res => {
					console.log(res)
					this.totalStr =res.data.data? `总提现金额：${res.data.total}元，选择时间范围内提现金额：${res.data.chooseTotal}元`:res.data.msg;
          for (let prop in res.data) {
            this[prop] = res.data[prop];
          }
        })
        .catch(error => {
          if (401 === error.response.status) {
            this.count = 0;
            this.data = [];
          }
        });
    },
    cell() {
      return { textAlign: "center" };
		},
		 exportExcel() {
      downloadExcel({
        method: "post",
        fileName:'商户交易数据报表.xls',
        url: `${shop_url}/shop/cms/print/withdraw`,
        data: this.formInline
      }).then(res => {
        console.log(res);
      });
    },
  }
};
</script>
<style scoped lang='scss'>
.findWrap {
  width: 100%;
  height: 120px;
  display: flex;
	justify-content: space-between;
  .com {
    flex: 1;
		margin-right: 20px
  }
  // .right {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  // }
  .dateWrap {
    .el-form--inline {
      .el-form-item__content {
        width: 600px;
      }
    }
  }
}
.total{
	border-left: 3px solid #30CE7E;
	background: rgba($color: #30CE7E, $alpha: 0.2);
	width: 100%;
	height: 40px;
	text-align: center;
	color: #323232;
	font-size: 14px;
	line-height: 40px;
}
.pageWrap {
  margin-top: 20px;
	margin-bottom: 20px;
  .el-pagination {
    text-align: center;
  }
}
.header {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchant/deposit.vue